/**************************************************
 * Nombre:       ListaProductos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import Tarjeta_Producto from "../../../Tarjetas/Tarjeta_Producto";

const ListaProductos = ({items, cargaMas}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    maxWidth: '1400px',
                    pt: 4,
                    pb: 4,
                    px: sCell ? 2 : 4,
                    backgroundColor: '#A4A9B310',
                    borderRadius: 2

                }}
                spacing={sCell ? 2 : 4}
            >

                {items.map((e, i) => (
                    <Grid container key={`Rs${i}`} size={{xs: 6, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Producto item={e}/>
                    </Grid>
                ))}

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Button
                        onClick={() => cargaMas()}
                        variant="outlined"
                    >Cargar Mas</Button>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default ListaProductos

